import type { Messages } from './en.js'

// Draft translations for UI chrome, pending professional review in Tolgee.
// Compliance and legal copy is never machine-translated — it stays in code
// (the disclaimer) or comes from the CRM (the AML form).
export const th: Messages = {
  'common.needHelp': 'ต้องการความช่วยเหลือ?',
  'common.continue': 'ดำเนินการต่อ',
  'common.back': 'ย้อนกลับ',

  'shell.cookiePolicy': 'นโยบายคุกกี้',
  'shell.privacyPolicy': 'นโยบายความเป็นส่วนตัว',
  'shell.cookiePreferences': 'การตั้งค่าคุกกี้',
  'shell.language': 'ภาษา',

  'login.title': 'เข้าสู่ระบบ',
  'login.subtitle': 'ใช้อีเมลที่ผูกกับบัญชีของคุณ',
  'login.forgot': 'ลืมรหัสผ่าน?',
  'login.createAccount': 'สร้างบัญชี',

  'forgot.title': 'รีเซ็ตรหัสผ่าน',
  'forgot.subtitle': 'เราจะส่งรหัส 6 หลักไปยังอีเมลของคุณเพื่อตั้งรหัสผ่านใหม่',
  'forgot.newTitle': 'ตั้งรหัสผ่านใหม่',
  'forgot.backToSignIn': 'กลับไปหน้าเข้าสู่ระบบ',

  'consent.message':
    'เราใช้คุกกี้เพื่อให้เว็บไซต์นี้ทำงาน และเมื่อได้รับความยินยอมจากคุณ เพื่อวัดผลและปรับปรุงเว็บไซต์',
  'consent.acceptAll': 'ยอมรับทั้งหมด',
  'consent.essentialOnly': 'เฉพาะที่จำเป็น',

  'common.email': 'อีเมล',
  'common.password': 'รหัสผ่าน',
  'common.tryAgain': 'ลองอีกครั้ง',
  'err.tooManyAttempts': 'พยายามมากเกินไป',
  'err.checkFailed': 'การตรวจสอบล้มเหลว',
  'err.otpDeliveryFailed': 'เราไม่สามารถส่งรหัสได้',
  'err.otpLocked': 'ใส่รหัสผิดหลายครั้งเกินไป',
  'err.otpExpired': 'รหัสนี้หมดอายุแล้ว',
  'err.countryNotPermitted': 'ไม่พร้อมให้บริการในประเทศของคุณ',
  'err.temporarilyUnavailable': 'ไม่พร้อมใช้งานชั่วคราว',
  'err.checkAnswers': 'ตรวจสอบคำตอบของคุณ',
  'err.somethingWrong': 'เกิดข้อผิดพลาด',

  'step.account': 'บัญชี',
  'step.identity': 'ยืนยันตัวตน',
  'step.compliance': 'ข้อกำหนด',
  'step.finish': 'เสร็จสิ้น',

  'account.emailTitle': 'เปิดบัญชีของคุณ',
  'account.emailSubtitle': 'เราจะส่งรหัส 6 หลักไปยังอีเมลของคุณเพื่อยืนยันที่อยู่',
  'account.botFailedTitle': 'โหลดการตรวจสอบบอตไม่สำเร็จ',
  'account.botFailedBody': 'คุณยังดำเนินการต่อได้ — เราจะยืนยันเมื่อคุณส่งข้อมูล',
  'account.send': 'ส่งรหัส',
  'account.sending': 'กำลังส่ง…',
  'account.haveAccount': 'มีบัญชีอยู่แล้ว?',
  'account.login': 'เข้าสู่ระบบ',
  'account.otpTitle': 'กรอกรหัสของคุณ',
  'account.otpSentTo': 'ส่งไปยัง {target} แล้ว',
  'account.otpTargetFallback': 'อีเมลของคุณ',
  'account.escalated': 'เราได้ส่งรหัสอีกชุดจากผู้ให้บริการรายอื่นแล้ว',
  'account.startAgain': 'เริ่มใหม่',
  'account.checking': 'กำลังตรวจสอบ…',
  'account.verify': 'ยืนยัน',
  'account.resend': 'ส่งรหัสอีกครั้ง',
  'account.tryAnotherWay': 'ฉันไม่ได้รับรหัส — ลองวิธีอื่น',
  'account.differentEmail': 'ใช้อีเมลอื่น',
  'account.profileTitle': 'ข้อมูลเพิ่มเติมเล็กน้อย',
  'account.profileSubtitle': 'นี่เป็นขั้นตอนสุดท้ายของการตั้งค่าบัญชี',
  'account.emailReadonlyHint': 'ยืนยันแล้วด้วยรหัสที่คุณเพิ่งกรอก',
  'account.country': 'ประเทศที่พำนัก',
  'account.countrySearch': 'ค้นหาประเทศ',
  'account.phone': 'โทรศัพท์',
  'account.consentBefore': 'ฉันยินยอมให้เก็บและใช้ข้อมูลส่วนบุคคลของฉันตาม',
  'account.consentAfter': ' และเข้าใจว่าอาจมีการติดต่อฉันเกี่ยวกับใบสมัคร',
  'account.creating': 'กำลังสร้าง…',
  'account.existsTitle': 'คุณมีบัญชีอยู่แล้ว',
  'account.signInInstead': 'เข้าสู่ระบบแทน',

  'partner.add': 'มีรหัสพาร์ทเนอร์หรือไม่?',
  'partner.label': 'รหัสพาร์ทเนอร์ / Link ID',
  'partner.confirm': 'ใช้รหัสนี้',
  'partner.remove': 'ลบ',
  'partner.close': 'ปิดช่องรหัสพาร์ทเนอร์',
  'partner.referredBy': 'แนะนำโดย',
  'partner.partnerId': 'รหัสพาร์ทเนอร์',
  'partner.country': 'ประเทศ',
  'partner.unavailable': 'เราตรวจสอบรหัสนี้ไม่ได้ กรุณาลองอีกครั้ง',

  'identity.notReadyTitle': 'ตั้งค่าบัญชีให้เสร็จก่อน',
  'identity.backToStep1': 'กลับไปขั้นตอนที่ 1',
  'identity.title': 'ยืนยันตัวตนของคุณ',
  'identity.subtitle':
    'กฎระเบียบกำหนดให้เราต้องยืนยันตัวตนของคุณก่อนที่คุณจะเทรดได้ ใช้เวลาประมาณสองนาที',
  'identity.startFailedTitle': 'ไม่สามารถเริ่มการยืนยันได้',
  'identity.step1': 'เตรียมหนังสือเดินทาง บัตรประชาชน หรือใบขับขี่ไว้ให้พร้อม',
  'identity.step2': 'คุณจะถ่ายภาพเอกสาร แล้วถ่ายเซลฟีสั้น ๆ',
  'identity.step3': 'อนุญาตให้เข้าถึงกล้องเมื่อเบราว์เซอร์ร้องขอ — การตรวจสอบทำงานไม่ได้หากไม่มี',
  'identity.starting': 'กำลังเปิด…',
  'identity.start': 'เริ่มการยืนยัน',
  'identity.partnerNote': 'คุณจะถูกนำไปยังพาร์ทเนอร์ตรวจสอบของเราและกลับมาที่นี่ทันที',
  'identity.inProgress': 'คุณเริ่มไว้แล้ว ดำเนินการต่อจะทำต่อจากที่ค้างไว้',
  'webview.title': 'เปิดหน้านี้ในเบราว์เซอร์ของคุณ',
  'webview.cameraWarn': 'กล้องมักใช้งานไม่ได้ใน {browser} และการยืนยันตัวตนจำเป็นต้องใช้กล้อง',
  'webview.namedBrowser': 'เบราว์เซอร์ในตัวของ {app}',
  'webview.thisBrowser': 'เบราว์เซอร์ในตัวของแอปนี้',
  'webview.iosInstruction': 'แตะไอคอนแชร์ แล้วเลือก Open in Safari',
  'webview.openInChrome': 'เปิดใน Chrome',
  'webview.androidInstruction': 'หรือใช้เมนูแล้วเลือก Open in browser',
  'webview.otherInstruction': 'คัดลอกที่อยู่ของหน้านี้ไปยังเบราว์เซอร์ปกติของคุณ',

  'confirm.title': 'ยืนยันข้อมูลของคุณ',
  'confirm.subtitle': 'เรากรอกข้อมูลเหล่านี้จากเอกสารของคุณ — ตรวจสอบความถูกต้องและแก้ไขส่วนที่ผิด',
  'confirm.saveFailedTitle': 'ไม่สามารถบันทึกข้อมูลของคุณได้',
  'confirm.idOutstandingTitle': 'เรายังต้องการเอกสารยืนยันตัวตนของคุณ',
  'confirm.idOutstandingBody':
    'การยืนยันตัวตนของคุณยังไม่เสร็จสมบูรณ์ กรุณากรอกข้อมูลด้านล่าง ดำเนินการต่อให้เสร็จได้เลย — เราจะส่งอีเมลเรื่องเอกสารให้คุณ',
  'confirm.firstName': 'ชื่อ',
  'confirm.lastName': 'นามสกุล',
  'confirm.dob': 'วันเกิด',
  'confirm.whereLive': 'คุณพำนักอยู่ที่ไหน?',
  'confirm.city': 'เมือง',
  'confirm.state': 'รัฐ / จังหวัด',
  'confirm.saving': 'กำลังบันทึก…',

  'compliance.stillCheckingTitle': 'เรากำลังตรวจสอบเอกสารของคุณ',
  'compliance.backToVerification': 'กลับไปการยืนยัน',
  'compliance.loading': 'กำลังโหลดแบบสอบถามของคุณ…',
  'compliance.loadFailedTitle': 'เราไม่สามารถโหลดแบบสอบถามได้',
  'compliance.stillStuck': 'ยังติดปัญหาอยู่?',
  'compliance.title': 'คำถามสุดท้ายอีกเล็กน้อย',
  'compliance.subtitle':
    'กฎระเบียบกำหนดให้เราต้องถามคำถามเหล่านี้ก่อนเปิดบัญชีของคุณ คำตอบจะถูกบันทึกพร้อมใบสมัคร',
  'compliance.submitting': 'กำลังส่ง…',
  'compliance.submit': 'ส่ง',
  'compliance.oneQuestionLeft': 'ยังมี 1 คำถามที่ต้องตอบ',
  'compliance.questionsLeft': 'ยังมี {count} คำถามที่ต้องตอบ',
  'compliance.saveAnswersFailed': 'เราไม่สามารถบันทึกคำตอบของคุณได้',

  'gate.stepToFinishTitle': 'มีขั้นตอนที่ต้องทำให้เสร็จก่อน',
  'gate.continueWhereLeft': 'ทำต่อจากที่ค้างไว้',

  'done.loadingDocs': 'กำลังโหลดเอกสารสุดท้ายอีกไม่กี่ฉบับ…',
  'done.loadFailedTitle': 'เราไม่สามารถโหลดเอกสารของคุณได้',
  'done.tryAgainMoment': 'โปรดลองอีกครั้งในอีกสักครู่',
  'done.title': 'สิ่งสุดท้าย',
  'done.readyToSubmit': 'ใบสมัครของคุณพร้อมส่งแล้ว',
  'done.pleaseAccept': 'โปรดอ่านและยอมรับเอกสารเหล่านี้ก่อนที่เราจะเปิดบัญชีให้คุณ',
  'done.agreeAll': 'ฉันได้อ่านและยอมรับเอกสารทั้ง {count} ฉบับแล้ว',
  'done.hideDocs': 'ซ่อนเอกสาร',
  'done.showDocs': 'แสดงเอกสาร {count} ฉบับ',
  'done.version': 'เวอร์ชัน {version}',
  'done.finishing': 'กำลังดำเนินการ…',
  'done.finishSignIn': 'เสร็จสิ้นและเข้าสู่ระบบ',
  'done.oneLeft': 'ยังมีเอกสาร 1 ฉบับที่ต้องยอมรับ',
  'done.docsLeft': 'ยังมีเอกสาร {count} ฉบับที่ต้องยอมรับ',
  'done.straightIn': 'เราจะพาคุณเข้าสู่บัญชีทันที — ไม่ต้องเข้าสู่ระบบอีก',
  'done.completeFailed': 'เราไม่สามารถดำเนินการใบสมัครของคุณให้เสร็จได้',
  'done.acceptEvery': 'โปรดยอมรับเอกสารทุกฉบับ',
  'done.getApps': 'ดาวน์โหลดแอปเทรด',
  'done.getAppsSubtitle': 'เมื่อเปิดบัญชีแล้ว คุณจะเทรดผ่าน MT5 หรือแอป KCM Trade',
  'done.onComputer': 'ใช้คอมพิวเตอร์อยู่?',
  'done.scanQr': 'สแกน QR โค้ด',
  'done.scanQrSuffix': 'เพื่อรับแอปบนโทรศัพท์ของคุณ',

  'kyc.approvedTitle': 'ยืนยันตัวตนแล้ว',
  'kyc.approvedBody': 'ขอบคุณ — ส่วนที่ยากที่สุดเสร็จแล้ว',
  'kyc.reviewTitle': 'เรากำลังตรวจสอบเอกสารของคุณ',
  'kyc.reviewBody':
    'เจ้าหน้าที่กำลังตรวจสอบอยู่ — โดยปกติไม่กี่ชั่วโมง และเราจะส่งอีเมลแจ้งคุณทันทีที่เสร็จ ไม่ต้องรอที่นี่ ดำเนินการส่วนที่เหลือให้เสร็จได้เลย',
  'kyc.questions': 'มีคำถาม?',
  'kyc.declinedTitle': 'เราไม่สามารถยืนยันตัวตนของคุณได้',
  'kyc.contactPrefix': 'ติดต่อ',
  'kyc.contactSuffix': 'แล้วเราจะดูแลต่อจากตรงนั้น',
  'kyc.expiredTitle': 'เซสชันหมดเวลาแล้ว',
  'kyc.expiredBody': 'เซสชันการยืนยันเปิดอยู่ได้ไม่นาน การเริ่มใหม่ใช้เวลาไม่กี่นาที',
  'kyc.continueAnyway': 'ดำเนินการสมัครต่อ',
  'kyc.finishLaterBody':
    'คุณสามารถทำใบสมัครส่วนที่เหลือให้เสร็จได้เลย เราจะส่งอีเมลเรื่องเอกสารยืนยันตัวตนแยกต่างหาก และบัญชีของคุณจะอยู่ระหว่างรอดำเนินการจนกว่าจะเรียบร้อย',
  'decline.document_unreadable':
    'ภาพเอกสารของคุณไม่ชัดพอที่จะอ่านได้ แสงที่ดีขึ้นและพื้นผิวเรียบมักช่วยแก้ปัญหาได้',
  'decline.face_mismatch': 'เซลฟีไม่ตรงกับรูปในเอกสาร',
  'decline.document_expired': 'เอกสารที่คุณใช้หมดอายุแล้ว',
  'decline.other': 'ระบบตรวจสอบอัตโนมัติไม่สามารถยืนยันตัวตนของคุณได้',

  'verify.checkFailedTitle': 'เราไม่สามารถตรวจสอบสถานะของคุณได้',
  'verify.checkFailedBody': 'การยืนยันของคุณถูกส่งแล้ว การรีเฟรชหน้านี้มักช่วยแก้ปัญหาได้',
  'verify.refresh': 'รีเฟรช',
  'verify.stillProcessingTitle': 'ยังดำเนินการอยู่',
  'verify.stillProcessingBody':
    'ใช้เวลานานกว่าปกติ เอกสารของคุณถูกส่งแล้วและไม่มีอะไรสูญหาย เราจะส่งอีเมลแจ้งคุณทันทีที่มีผล',
  'verify.back': 'ย้อนกลับ',
  'verify.checkingTitle': 'กำลังตรวจสอบเอกสารของคุณ',
  'verify.checkingBody': 'โดยปกติใช้เวลาไม่กี่วินาที โปรดอย่าปิดหน้านี้',
  'verify.checkingAria': 'กำลังตรวจสอบการยืนยันของคุณ',
  'handoff.receivedTitle': 'ได้รับเอกสารแล้ว',
  'handoff.receivedBody': 'ขอบคุณ — นี่คือทุกอย่างที่เราต้องการจากโทรศัพท์ของคุณ',
  'handoff.goBackTitle': 'กลับไปที่คอมพิวเตอร์ของคุณ',
  'handoff.goBackBody':
    'ใบสมัครของคุณยังเปิดอยู่ในเบราว์เซอร์ที่คุณเริ่มไว้ ทำต่อที่นั่น — หน้าจะดำเนินต่อเองเมื่อการตรวจสอบเสร็จ',
  'handoff.closeTab': 'คุณสามารถปิดแท็บนี้ได้',
  'handoff.somethingWrong': 'มีบางอย่างไม่ถูกต้อง?',
}
